import { render, staticRenderFns } from "./zc.vue?vue&type=template&id=a08d4a62&scoped=true&"
import script from "./zc.vue?vue&type=script&lang=js&"
export * from "./zc.vue?vue&type=script&lang=js&"
import style0 from "./zc.vue?vue&type=style&index=0&id=a08d4a62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08d4a62",
  null
  
)

export default component.exports